function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHingeSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50.8 50.8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.558 5.792V44.95M31.99 5.792l.264 39.158M11.113 31.22s3.493-5.812 8.441-6.378c5.258-.602 10.583 0 15.875 0 0 0 7.408 0 9.525-4.233",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3.175,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHingeSvg);
export default __webpack_public_path__ + "static/media/hinge_svg.136f62567da60822d2a912f358a0f288.svg";
export { ForwardRef as ReactComponent };